import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  response: undefined,
  error: undefined,
};

export const NotificationsSlice = createSlice({
  name: "NotificationsLogs",
  initialState,
  reducers: {
    getNotificationsRequest(state) {
      state.loading = true;
    },
    getNotificationsSuccess(state, action) {
      state.loading = false;
      state.response = action.payload;
      state.error = undefined;
    },
    getNotificationsError(state, action) {
      state.loading = false;
      state.error = action.payload;
      state.response = undefined;
    },
  },
});

export const {
  getNotificationsRequest,
  getNotificationsSuccess,
  getNotificationsError,
} = NotificationsSlice.actions;

export default NotificationsSlice.reducer;
